import { Action, createReducer, on } from '@ngrx/store';
import { FlightChangeFlagModel } from './changed-flight-state.model';
import * as ChangedFlightFlagStateActions from './changed-flight-state.actions';

const initialState: FlightChangeFlagModel = new FlightChangeFlagModel();

const reducer = createReducer(
  initialState,
  on(
    ChangedFlightFlagStateActions.setChangedFlightFlagState,
    (state, { wasFlightChangeConfirmed }: FlightChangeFlagModel) => ({ wasFlightChangeConfirmed } as FlightChangeFlagModel)
  )
);

export function changedFlightFlagReducer(state: FlightChangeFlagModel, action: Action) {
  return reducer(state, action);
}
